import React, { Component } from 'react';
import Text from '../containers/Text';
import { Map } from 'immutable';
import Popin from '../containers/Popin';
import EspPersoSteps from '../containers/EspPersoSteps';
import TimelineEP from '../containers/TimelineEP';
import { format } from '../utile/utile';
import SelectCountry from '../containers/Inputs/SelectCountry';
import loading from '../assets/images/loading.gif';
import { hashHistory } from 'react-router';
import Accordion from './Inputs/Accordion';
import Textarea from '../containers/Inputs/Textarea';
import {formatDureCreditAns,formatDureCreditMois} from '../utile/utile';
import taux_icone from '../assets/images/taux_icone.png';
import dtc_icone from '../assets/images/dtc_icone.png';
import ie_icone from '../assets/images/ie_icone.png';
import somme_icone from '../assets/images/somme_icone.png';
import mensualite_icone from '../assets/images/mensualite_icone.png';


const divStyle = { display: 'block' };

class EspacePerso extends Component {
  constructor(props){
    super(props);
    this.state={
      dureCreditAns : null,
      dureCreditMois : null,
      opened : null
    }
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    this.props.getDemande();
    this.accepterProposition = this.accepterProposition.bind(this);
    this.getRejetPropComm=this.getRejetPropComm.bind(this);
    this.shoHidePop = this.shoHidePop.bind(this);
    this.shoHidePopRejet = this.shoHidePopRejet.bind(this);
    this.initDureeCredit();
    this.shoHidePopRejet();
    this.setState({opened: true});
  }

  initDureeCredit(){
    this.setState({
      dureCreditAns : formatDureCreditAns(this.props.maProposition.get('duree_accordee')),
      dureCreditMois : formatDureCreditMois(this.props.maProposition.get('duree_accordee'))
  })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dateNaissance !== this.props.dateNaissance) {
        this.props.inputChange(this.props.dateNaissance, 'demandeCredit.dateNaissance');
        this.props.inputChange(this.props.mail, 'demandeCredit.mail');
        this.props.inputChange(this.props.paysresid, 'demandeCredit.paysresid');
        this.props.inputChange(this.props.nom, 'demandeCredit.nom');
        this.props.inputChange(this.props.prenom, 'demandeCredit.prenom');
        this.props.inputChange(this.props.teleph, 'demandeCredit.telephon');
      }
      if((prevProps.propositionStatus !== this.props.propositionStatus) && (this.props.propositionStatus === 'success') && (this.state.opened === true)) {
        this.props.getDemande();
        this.setState({opened: false });
      }

      if (prevProps.maProposition.get('duree_accordee') !== this.props.maProposition.get('duree_accordee')) {
        this.initDureeCredit();
      }
    }
  shoHidePop() {
    this.props.showHide('demandeCredit.proposition');
  }
  shoHidePopRejet() {
    this.props.showHide('demandeCredit.propositionRejetPop');
  }


  initierDemande() {
    hashHistory.push('/coordonnees');
  }

  getRejetPropComm(){
    this.props.getRejetPropComm();
    this.shoHidePopRejet();
  }

  accepterProposition() {
    this.props.accepterProposition();
    this.shoHidePop();
  }
  renderLoading() {
    document.body.classList.remove('hiddenScroll');
    return (
      <div >
        <div className="loader_back">
          <img
            className="relativePosition"
            src={loading} alt="loading"
          />
        </div>
      </div>
    );
  }
  renderSuccess() {
    return (
      <div>
        {this.props.propositionStatus === 'loading' &&
        <div >
        <div className="loader_back">
          <img
            className="relativePosition"
            src={loading} alt="loading"
          />
        </div>
      </div>
        }
        <div className="espace_perso_bandeau mb35">
          <div className="detail_sim_heading">
            <p className="slide_txt bold_style" style={{ fontSize: '31' }}>
            Bonjour {this.props.civilite}. {this.props.prenom} {this.props.nom},
            </p>
            <p className="slide_txt bold_style" style={{ fontSize: '31' }}>
          Bienvenue dans votre espace personnel
            </p>
          </div>
        </div>
        <div className="qualif_class">
          <ul className="accordion_list1">
            <li>
              <Accordion
                title="mes informations personnelles"
              >
                <div className="" style={divStyle}>
                  <div className="accordion_padding">
                    <div className="control_group clearfix">
                      <div className="left_cls">
                      </div>
                    </div>
                    <div className="control_group clearfix">
                      <div className="left_cls">
                        <Text maxLength="35" storeKey="demandeCredit.nom" disabled>
                            Nom
                        </Text>
                      </div>
                      <div className="right_cls">
                        <Text maxLength="35" storeKey="demandeCredit.prenom" disabled>
                            Prénom
                        </Text>
                      </div>
                    </div>
                    <div className="control_group clearfix">
                      <div className="left_cls">
                        <Text maxLength="35" storeKey="demandeCredit.dateNaissance" disabled>
                            Date de naissance
                        </Text>
                      </div>
                      <div className="right_cls">
                        <SelectCountry
                          storeKey="demandeCredit.paysresid"
                          disabled
                        >
                        Pays de résidence
                        </SelectCountry>
                      </div>
                    </div>
                    <div className="control_group clearfix">
                      <div className="left_cls">
                        <Text
                          type="email"
                          storeKey="demandeCredit.mail"
                          disabled
                        >
                          e-mail
                        </Text>
                      </div>
                      <div className="right_cls">
                        <Text maxLength="35" storeKey="demandeCredit.telephon" disabled>
                          N° mobile
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
              </Accordion>
            </li>
            <li>
              <Accordion
                style={{ display: 'block' }}
                title="mes demandes de prêt"
              >
                <div className="" style={divStyle}>
                  <div className="accordion_padding">
                    <TimelineEP />
                    <EspPersoSteps />
                  </div>
                </div>
              </Accordion>
            </li>
          </ul>
          {this.props.showHideElm ?
          null :
            <Popin
              classCss="flat_btn purple_btn"
              dataText="accepter la proposition"
              datalabel="accepter la proposition"
              secondBtnclassCss="flat_btn white_btn"
              secondBtnDataText="annuler"
              secondBtnDatalabel="annuler"
              action={this.accepterProposition}
              secondAction={this.shoHidePop}
              storeKey="demandeCredit.proposition"
              popin_modals="popin_dialog big_size"
              popinTitle="Proposition commerciale"
              popinTagLine="Détail de la proposition commerciale"
              withWhiteBtn
            >
              <div className="body_tpl mb30">
                <div className="p30">
                  <div className="display_table profil_detail_sim">
                    <div className="row_table">
                      <div className="cell_table default_size recap_montant">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABgCAMAAACAJ2RUAAAAkFBMVEUAAABbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZ06DwKAAAAL3RSTlMABvgNFfKnHDHpmINZSjpnKM23eiLgbshCCe0t27yxh1JOkIvUnl/k2MJyk2OidXezBxAAAARKSURBVFjD7djXcqNAEAXQOwxZIogkgnKygu3+/7/bJWhgAbFKjzovrlJ5mkndTYFhuol34Vsy8CZWSEQB3kFWKefjDb4VKhzxMvdEVyu8ho0kEnYMr7CP1PSN5/E9/SvV8KyxQW0LPCfwqMcYT2C/CvVRMjxMn1BhYskIzhLVZvzxRCypDLmsOUuPPZiI7VlE1LB8ZLdUMWwtfktJeCxH6zUluJpSk4O7iYFG57fHL4hJFUlsdSJm+2jKj8WQGOIAWqR75yaLIdNqaq5EHRHuMxcj5kVirwzqMcIdlvqBBEWNRifqZzL8j0NqYlC/2daxddtxRl4q8mPImohcn/r8ZKi5I4PoJGOInW/1ns+oY+p2Tv2LjkPFUisXGMR3bTe/kGHjlqQqPB5EvR5OoIgkCzeIFLdk475r4Ny8cN/1sbG4eU/nDAPP36BPY9v9OvLwS4YmEakJuuy0zj0by7q2YoCan7SMLr3eqS+53kHnv2VhFvRNetrYJ1FybQxwKZfa6ErqO7EFqyqbfkeNkVbdOesYizp4AbblRcGA4FZnYGEaQzuJZEzw+992tCbxcNbZTJ/hXE0uP6W1kt+6wdMUPI6GIpt2OrTrfxgxstngcWbUMJEh2NcuyxEfr4nE+IKUADfwKTWFdZX6ET3OYcyv1nrSEEk7+Uasefu9RlyRjVQn5xh8WYZL13B3x965WV/UVlcRbZPW619BrqKbnC2ViKFlVUxroAmy9UL8fDwwzSzChTHiMIxkCNpYbc+q++KbccjnndhPJ5F9o0iHhKtEU3N7Nk3Tq2povcUB5HXYaanL1OdANroeUrrV2CEfe7RFbrQd5fbBjqtgRMrGBiAfFtXYRQxbLS5JcOrdJB2lQGq9iy3L5Y1cAMy6lPuyy1c7o10GX6IOsycZJE0Ey4UbKwGgj+ZKuVrEe8NndrcJrnHltx6wbM7f+9WRB4zUsFgtW58DvqcWvRvswnrfndJFGVAbb3Y7h4MBq/ocWgVqUU0iQoXH0b518sp8tJYBcOsc53/d5lJFcxIvXqENJBw1d3X+e5uaux2qZ5uhxL1/TtNFgZVz8GRA52N0JPra2ewnR5Fi5qEcOaKGL6t4/lS0a/eQ/GBApltOZJr7yWTu5Ys+SNTg+b8LqYgbA5A95oxwt0CG1ZcOKocONrdYaOEhoscKyhjaRYbpIZISPCZrRfM0jHcBHCngqYpHuc1o0hnyQslgS0uMaIWHZUpdSl2sDCmGZqRcU5QEj7OobjtqXnnYlByYtMUznLLnZEU38PP7N2H60995tkTGAdjkxbhoojbmT38VYJ7P8c1WRCoAdlLzpcd4GjPpB/6cwb1A03Ai9YVYi6Loc7AdHZBXKA3P21RfYlhIRTQXL2DzvOvoWlFKvACvkYtiqcLNywbHi3QpzwFgmtfwl33nL4ZARCbeYF90N3nF8AY8JBtvY2/w8fHx8fFRoTd6a7A/+j5UHzpbr+EAAAAASUVORK5CYII=" alt="" width="38px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">Montant du crédit</span><br />
                            <span className="detail_sim_num">
                             {this.props.maProposition.get('montant_accorde')}
                              <span>Dhs</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table default_size recap_duree">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src="data:image/png;base64,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" alt="" width="39px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">durée du crédit</span><br />
                            <span className="detail_sim_num">
                               {this.state.dureCreditAns}
                                <span>Ans </span>
                              {this.state.dureCreditMois > 0 && this.state.dureCreditMois}
                              {this.state.dureCreditMois > 0 &&  <span>Mois</span> }
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table recap_taux size180">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src={taux_icone} alt="" width="38px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">taux
                              <span>(ht)</span>
                            </span><br />
                            <span className="detail_sim_num">
                             {this.props.maProposition.get('taux_accorde')}
                              <span>%</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table recap_diff size180">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABUCAMAAAAiXkCJAAAAQlBMVEUAAABbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkbN5D2IAAAAFXRSTlMAgPD5qcIVbyvyCaCIENixk+nn05TCOeMUAAAA80lEQVRYw+3WO27DQAxFUQ0pMZmPPnby9r/VAFKUYuyoIJ4LA7yVwOI0IogZLrOU7MnEXwLS5WRvVCOD0EQGkRsZhGxkEFLJIPLqBj+7DhB5Kj5QHsKRfs0e8Ko7G9TZA+pDf575fspH14ijm1HXRpeZuoc6FeZi72vNBKVyj4Ns3PMljXtgWxpY4FmALwfrVLjgqMvMBYG7kUGokUFoIoPIjQxCNh9o0qf4FasLTPi3vJJBCBmUzQPa1LfgKDfuX9bEXRs17h7ebGCC+73hgfu7ggnmlXtgv+v5ZXo++bqJu1KeTKIoiqIoiqIoevNA7AXgD70aNDdliJZPAAAAAElFTkSuQmCC" alt="" width="40px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">différé</span><br />
                            <span className="detail_sim_num">
                              {this.props.maProposition.get('differe_accorde')}
                              <span>Mois</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row_table">
                      <div className="cell_table half_size">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={dtc_icone} alt="" width="38" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">
                              Assurance décès toutes causes
                            </span>
                            <br />
                            <span className="detail_sim_num">
                            {this.props.maProposition.get('frais_assur_dtc')}
                              <span>
                                Dhs
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table half_size">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={ie_icone} alt="" width="39px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">
                            assurance incendie explosion
                            </span>
                            <br />
                            <span className="detail_sim_num">
                            {this.props.maProposition.get('frais_assur_ie')}
                              <span>
                                Dhs
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row_table">
                      <div className="cell_table default_size ligh_grey_bg">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={somme_icone} alt="" width="38" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <div className="detail_sim_labels">
                            coût total du crédit
                            </div>
                            <div className="cout_total_cridet_details">
                              <span className="cout_txt">
                              {this.props.maProposition.get('interets')}
                                <span>
                                  Dhs<br />(Interêts)
                                </span>
                              </span>
                              <span className="cout_txt mLeft">
                                    {format(this.props.maProposition.get('frais_assur_dtc')
                                    + this.props.maProposition.get('frais_assur_ie'))
                                  }
                                <span>
                                  Dhs<br />(Assurances)
                                </span>
                              </span>
                              <span className="cout_txt mLeft">
                                  {this.props.maProposition.get('frais_dossier')}
                                <span>
                                  Dhs<br />(Frais de dossier)
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table orange_bg size360">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={mensualite_icone} alt="" width="39" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels white-txt">
                            mensualité ttc
                            </span>
                            <br />
                            <span className="detail_sim_num white-txt">
                            {this.props.maProposition.get('echeance')}
                              <span className="white-txt">
                                Dhs
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="popin_notification mb20">
                  Vous avez choisi d’accepter la proposition commerciale liée à votre demande
                  de crédit immobilier ?
                </div>
              </div>
            </Popin>
        }
        </div>
        <div>
        { this.props.showHideElmRejetPop ? null:
            <Popin
              classCss="flat_btn purple_btn"
              dataText="Refuser la proposition"
              datalabel="Refuser la proposition"
              secondBtnclassCss="flat_btn white_btn"
              secondBtnDataText="Annuler"
              secondBtnDatalabel="Annuler"
              action={this.getRejetPropComm}
              secondAction={this.shoHidePopRejet}
              storeKey="demandeCredit.propositionRejetPop"
              popin_modals="popin_dialog big_size"
              popinTitle="Refus de la proposition commerciale"
              withWhiteBtn
            >
            <div className="centerText">Vous souhaitez refuser la proposition de financement ? <br/> Merci d'indiquer votre motif de rejet.</div><br/>
            <div className="sliders_container">
                <div className="accordion_padding">
                  <Textarea
                    placeholder="Veuillez saisir le motif de rejet..."
                    areaRows="50"
                    areaCols="800"
                    storeKey="demandeCredit.motifRejet"
                  />
                </div>
              </div>
              </Popin>
         }</div>
      </div>
    );
  }
  renderAddDemande() {
    return (
      <div>
        <div className="nav_btns_container">
          <div className="next_btn_container">
            <button
              data-text="Initier une demande"
              className="flat_btn purple_btn more_padding"
              onClick={this.initierDemande}
            >
              <span>Initier une demande</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div>
      {(() => {
        switch (this.props.maDemandeStatus) {
          case 'loading':
            return this.renderLoading();
          case 'success':
            return this.renderSuccess();
          case 'error':
            return this.renderAddDemande();
          default:
            return null;
        }
      })()}
      </div>
    );
  }
}
EspacePerso.propTypes = {
  showHideElmRejetPop: React.PropTypes.bool,
  inputChange: React.PropTypes.func,
  showHide: React.PropTypes.func,
  espacePerso: React.PropTypes.object,
  showHideElm: React.PropTypes.bool,
  maDemandeStatus: React.PropTypes.bool,
  statutEncours: React.PropTypes.string,
  maProposition: React.PropTypes.instanceOf(Map),
  maDemande: React.PropTypes.instanceOf(Map),
  accepterProposition: React.PropTypes.func,
  getDemande: React.PropTypes.func,
  civilite: React.PropTypes.string,
  prenom: React.PropTypes.string,
  nom: React.PropTypes.string,
};


export default EspacePerso;
